var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97.662,
    height: 97.662,
    viewBox: "0 0 97.662 97.662",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "I_Ico",
    "data-name": "I Ico",
    transform: "translate(0 9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6677",
    "data-name": "Rect\\xE1ngulo 6677",
    width: 97.662,
    height: 97.662,
    transform: "translate(0 -9)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20009",
    "data-name": "Trazado 20009",
    d: "M37.885,9.6A31.377,31.377,0,0,1,25.351,7.089,32.636,32.636,0,0,1,15.074.133,32.583,32.583,0,0,1,8.118-10.16,31.412,31.412,0,0,1,5.611-22.678,31.532,31.532,0,0,1,8.118-35.212,32.336,32.336,0,0,1,15.074-45.5a32.774,32.774,0,0,1,10.276-6.939,31.377,31.377,0,0,1,12.534-2.507A31.413,31.413,0,0,1,50.4-52.444,32.523,32.523,0,0,1,60.679-45.5a32.472,32.472,0,0,1,6.939,10.293,31.532,31.532,0,0,1,2.507,12.534A31.412,31.412,0,0,1,67.618-10.16,32.721,32.721,0,0,1,60.679.133,32.387,32.387,0,0,1,50.4,7.089,31.412,31.412,0,0,1,37.885,9.6Zm0-5.91A25.582,25.582,0,0,0,48.111,1.627a26.887,26.887,0,0,0,8.417-5.678,26.147,26.147,0,0,0,5.661-8.384,25.908,25.908,0,0,0,2.025-10.243,25.908,25.908,0,0,0-2.025-10.243A26.147,26.147,0,0,0,56.528-41.3a26.887,26.887,0,0,0-8.417-5.678,25.582,25.582,0,0,0-10.227-2.059,25.546,25.546,0,0,0-10.243,2.059,26.941,26.941,0,0,0-8.4,5.678,26.373,26.373,0,0,0-5.678,8.384,25.726,25.726,0,0,0-2.042,10.243,25.726,25.726,0,0,0,2.042,10.243,26.373,26.373,0,0,0,5.678,8.384,26.941,26.941,0,0,0,8.4,5.678A25.546,25.546,0,0,0,37.885,3.686ZM32.373-5.279a2.365,2.365,0,0,1-1.693-.664,2.2,2.2,0,0,1-.7-1.66,2.176,2.176,0,0,1,.7-1.61,2.334,2.334,0,0,1,1.693-.681h3.785V-23.607H32.9a2.4,2.4,0,0,1-1.693-.647,2.184,2.184,0,0,1-.7-1.677,2.16,2.16,0,0,1,.7-1.627,2.365,2.365,0,0,1,1.693-.664h5.91a2.342,2.342,0,0,1,1.926.813,3.335,3.335,0,0,1,.664,2.175v15.34H45.09a2.334,2.334,0,0,1,1.693.681,2.176,2.176,0,0,1,.7,1.61,2.2,2.2,0,0,1-.7,1.66,2.365,2.365,0,0,1-1.693.664Zm5.246-27.99a4,4,0,0,1-2.938-1.212,4,4,0,0,1-1.212-2.938,4.1,4.1,0,0,1,1.212-2.988,3.974,3.974,0,0,1,2.938-1.229,4.013,4.013,0,0,1,2.972,1.229A4.1,4.1,0,0,1,41.8-37.42a4,4,0,0,1-1.212,2.938A4.041,4.041,0,0,1,37.619-33.27Z",
    transform: "translate(12 64.662)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlack);
export default __webpack_public_path__ + "static/media/info-black.d57696792689b8ebafb5233cb0ab37aa.svg";
export { ForwardRef as ReactComponent };